angular.module('bizmetryApp').controller('NotificationsDialogController', function (
  $scope,
  $mdDialog,
  $timeout,
  NotificationService,
  ConfigurationService
) {

  function getAccountId() {
    const user = JSON.parse(sessionStorage.getItem("user"));
    return user?.id;
  }

  const accountId = getAccountId();

  // ─────────────────────────────────────────────────────────
  // State
  // ─────────────────────────────────────────────────────────
  $scope.notifications           = [];
  $scope.page                    = 0;
  $scope.totalPages              = 0;
  $scope.totalElements           = 0;
  $scope.loading                 = false;
  $scope.dataReady               = false;
  $scope.noContentFound          = false;
  $scope.activeObjectFilterLabel = null;
  $scope.pageSize                = 10;

  $scope.subject_max_len     = ConfigurationService.getFromCache('frontend.home.notifications.subject_max_len')     || 30;
  $scope.object_name_max_len = ConfigurationService.getFromCache('frontend.home.notifications.object_name_max_len') || 30;

  // ─────────────────────────────────────────────────────────
  // Object filter data
  // ─────────────────────────────────────────────────────────
  $scope.notificationObjects  = [];
  $scope.availableObjectTypes = [];
  $scope.filteredObjectNames  = [];

  // ─────────────────────────────────────────────────────────
  // Filters model
  // ─────────────────────────────────────────────────────────
  $scope.filters = {
    status:        null,
    type:          null,
    severity:      null,
    createdAfter:  null,
    createdBefore: null,
    objectType:    null,
    objectId:      null
  };

  // ─────────────────────────────────────────────────────────
  // Load distinct notification objects for filter dropdowns
  // ─────────────────────────────────────────────────────────
  function loadNotificationObjects() {
    NotificationService.getNotificationObjects(accountId)
      .then(function (response) {
        if (response.status === 204 || !response.data || response.data.length === 0) {
          $scope.notificationObjects  = [];
          $scope.availableObjectTypes = [];
          return;
        }

        $scope.notificationObjects = response.data;

        const seen  = {};
        const types = [];
        response.data.forEach(function (obj) {
          if (obj.object_type && !seen[obj.object_type]) {
            seen[obj.object_type] = true;
            types.push(obj.object_type);
          }
        });
        $scope.availableObjectTypes = types.sort();
      })
      .catch(function (err) {
        console.warn('Could not load notification objects:', err);
        $scope.notificationObjects  = [];
        $scope.availableObjectTypes = [];
      });
  }

  // ─────────────────────────────────────────────────────────
  // Object type change
  // ─────────────────────────────────────────────────────────
  $scope.onObjectTypeChange = function () {
    $scope.filters.objectId = null;

    if (!$scope.filters.objectType) {
      $scope.filteredObjectNames = [];
      return;
    }

    // Dedupe by objectId — the same underlying object can appear under more
    // than one objectName here if it was renamed between when different
    // historical alerts were generated (e.g. a biz interceptor renamed after
    // its first alert fired), and the <md-option ng-repeat="... track by
    // obj.objectId"> in the Object Name select throws AngularJS's own
    // ngRepeat:dupes error on a duplicate key — which blanks out the WHOLE
    // dropdown, not just the one extra entry. Filtering by objectId returns
    // the same results regardless of which name was picked anyway, so
    // keeping just the first name seen per id is safe.
    const seenIds = {};
    $scope.filteredObjectNames = $scope.notificationObjects
      .filter(function (obj) {
        return obj.object_type === $scope.filters.objectType;
      })
      .reduce(function (acc, obj) {
        if (!seenIds[obj.object_id]) {
          seenIds[obj.object_id] = true;
          acc.push({ objectId: obj.object_id, objectName: obj.object_name });
        }
        return acc;
      }, []);
  };

  // ─────────────────────────────────────────────────────────
  // Active filter label chip
  // ─────────────────────────────────────────────────────────
  function buildActiveObjectLabel() {
    if (!$scope.filters.objectType) {
      $scope.activeObjectFilterLabel = null;
      return;
    }

    if ($scope.filters.objectId) {
      const found = $scope.filteredObjectNames.find(function (o) {
        return o.objectId === $scope.filters.objectId;
      });
      $scope.activeObjectFilterLabel = $scope.filters.objectType
        + ' › '
        + (found ? found.objectName : $scope.filters.objectId);
    } else {
      $scope.activeObjectFilterLabel = $scope.filters.objectType + ' (all)';
    }
  }

  // ─────────────────────────────────────────────────────────
  // Clear object filter
  // ─────────────────────────────────────────────────────────
  $scope.clearObjectFilter = function () {
    $scope.filters.objectType      = null;
    $scope.filters.objectId        = null;
    $scope.filteredObjectNames     = [];
    $scope.activeObjectFilterLabel = null;
    $scope.loadPage(0);
  };

  // ─────────────────────────────────────────────────────────
  // Load page
  // ─────────────────────────────────────────────────────────
  $scope.loadPage = function (page) {
    $scope.dataReady = false;
    $scope.loading   = true;

    $timeout(function () {
      $scope.notifications = [];

      NotificationService.getFilteredNotifications(accountId, $scope.filters, page, $scope.pageSize)
        .then(function (response) {
          const data = response.data;

          if (response.status === 204) {
            $scope.noContentFound = true;
            $scope.notifications  = [];
            $scope.page           = 0;
            $scope.totalPages     = 0;
            $scope.totalElements  = 0;
            $scope.lastPage       = true;
            $scope.firstPage      = true;
          } else {
            $scope.noContentFound = false;

            $timeout(function () {
              $scope.notifications = data.content || [];
              $scope.page          = data.number;
              $scope.totalPages    = data.totalPages;
              $scope.totalElements = data.totalElements;
              $scope.lastPage      = data.last;
              $scope.firstPage     = data.first;
              $scope.dataReady     = true;
            }, 50);
          }
        })
        .catch(function (error) {
          console.error('Error loading notifications:', error);
          $scope.noContentFound = true;
          $scope.notifications  = [];
          $scope.page           = 0;
          $scope.totalPages     = 0;
          $scope.totalElements  = 0;
          $scope.dataReady      = false;
        })
        .finally(function () {
          $scope.loading = false;
        });
    }, 0);
  };

  // ─────────────────────────────────────────────────────────
  // Pagination
  // ─────────────────────────────────────────────────────────
  $scope.nextPage = function () {
    if ($scope.page < $scope.totalPages - 1 && !$scope.loading) {
      $scope.loadPage($scope.page + 1);
    }
  };

  $scope.prevPage = function () {
    if ($scope.page > 0 && !$scope.loading) {
      $scope.loadPage($scope.page - 1);
    }
  };

  $scope.goToFirstPage = function () {
    if (!$scope.firstPage && !$scope.loading) {
      $scope.loadPage(0);
    }
  };

  $scope.goToLastPage = function () {
    if (!$scope.lastPage && !$scope.loading) {
      $scope.loadPage($scope.totalPages - 1);
    }
  };

  // ─────────────────────────────────────────────────────────
  // Page size change
  // ─────────────────────────────────────────────────────────
  $scope.onPageSizeChange = function () {
    $scope.page = 0;
    $scope.loadPage(0);
  };

  // ─────────────────────────────────────────────────────────
  // Apply / Clear filters
  // ─────────────────────────────────────────────────────────
  $scope.applyFilters = function () {
    buildActiveObjectLabel();
    $scope.page = 0;
    $scope.loadPage(0);
  };

  $scope.clearFilters = function () {
    $scope.filters = {
      status:        null,
      type:          null,
      severity:      null,
      createdAfter:  null,
      createdBefore: null,
      objectType:    null,
      objectId:      null
    };
    $scope.filteredObjectNames     = [];
    $scope.activeObjectFilterLabel = null;
    $scope.page = 0;
    $scope.loadPage(0);
  };

  // ─────────────────────────────────────────────────────────
  // Dialog close
  // ─────────────────────────────────────────────────────────
  $scope.close = function () {
    $mdDialog.hide();
  };

  // ─────────────────────────────────────────────────────────
  // Count by status
  // ─────────────────────────────────────────────────────────
  $scope.getCountByStatus = function (status) {
    if (!$scope.notifications || $scope.notifications.length === 0) return 0;
    return $scope.notifications.filter(function (n) {
      return n.notificationStatus === status;
    }).length;
  };

  // ─────────────────────────────────────────────────────────
  // Open notification detail dialog — templateUrl instead of inline
  // ─────────────────────────────────────────────────────────
  $scope.openMessageDialog = function (notification) {
    $mdDialog.show({
      parent:              angular.element(document.body),
      multiple:            true,
      clickOutsideToClose: true,
      escapeToClose:       true,
      templateUrl:         '/home/main-menu/notifications/notification-detail-dialog.html',
      controller: function ($scope, $mdDialog, $sce) {

        $scope.notification = notification;

        const raw = notification.messageBody;
        $scope.messageBody = angular.isString(raw)
          ? $sce.trustAsHtml(raw)
          : $sce.trustAsHtml('<p style="color:#999;font-style:italic;">No content available</p>');

        $scope.getNotificationIcon = function (type) {
          const icons = { EMAIL: 'email', ALERT: 'notification_important', SMS: 'sms' };
          return icons[type] || 'mail';
        };

        $scope.getSeverityIcon = function (severity) {
          const icons = { INFO: 'info', NOTICE: 'announcement', ERROR: 'error', FATAL: 'dangerous' };
          return icons[severity] || 'info';
        };

        $scope.getStatusIcon = function (status) {
          const icons = {
            QUEUED: 'schedule', SENT: 'check_circle', FAILED: 'error',
            ABORTED: 'cancel', DISPATCHING: 'sync'
          };
          return icons[status] || 'help';
        };

        $scope.getDeliveryCodeClass = function (code) {
          const map = {
            SUCCESS:                    'delivery-success',
            FAILED_NON_RETRYABLE:       'delivery-failed',
            FAILED_MAX_RETRIES_EXCEEDED:'delivery-failed',
            FAILED_EXCEPTION:           'delivery-failed-exception'
          };
          return map[code] || 'st-aborted';
        };

        $scope.getDeliveryCodeIcon = function (code) {
          const map = {
            SUCCESS:                    'check_circle',
            FAILED_NON_RETRYABLE:       'cancel',
            FAILED_MAX_RETRIES_EXCEEDED:'replay_circle_filled',
            FAILED_EXCEPTION:           'bug_report'
          };
          return map[code] || 'help';
        };

        $scope.close = function () { $mdDialog.hide(); };
      }
    });
  };

  // ─────────────────────────────────────────────────────────
  // CSS helpers (pills)
  // ─────────────────────────────────────────────────────────
  $scope.getSeverityClass = function (severity) {
    const map = { INFO: 'pill-blue', NOTICE: 'pill-green', ERROR: 'pill-orange', FATAL: 'pill-red' };
    return map[severity] || 'pill-gray';
  };

  $scope.getStatusClass = function (status) {
    const map = { QUEUED: 'pill-blue', SENT: 'pill-green', FAILED: 'pill-red' };
    return map[status] || 'pill-gray';
  };

  $scope.getTypeClass = function (type) {
    const map = { EMAIL: 'pill-purple', SMS: 'pill-yellow' };
    return map[type] || 'pill-gray';
  };

  $scope.getObjectTypeClass = function (type) {
    const map = { AGENT: 'pill-purple', PROFILE: 'pill-yellow', ENVIRONMENT: 'pill-yellow' };
    return map[type] || 'pill-gray';
  };

  // ─────────────────────────────────────────────────────────
  // Init
  // ─────────────────────────────────────────────────────────
  loadNotificationObjects();
  $scope.loadPage(0);
});